module.exports = __webpack_public_path__ + "img/bank-logo.0c44b5e7.png";